var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDividerTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 149,
    viewBox: "0 0 1280 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M907.5 82.9999C1065.5 39.9999 1201 91.4999 1282.5 149H0V37.4999C70 28.3332 239.5 15.4999 357.5 37.4999C505 64.9999 749.5 126 907.5 82.9999Z",
    fill: "#916BBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M987.276 0C1112.19 0 1180.42 28 1280.75 62V149H0V124.5C23.5782 124.5 86.788 121.5 151.001 109.5C231.267 94.5 286.952 83.5 352.67 88.5C418.388 93.5 454.007 111 506.681 124.5C559.356 138 660.692 108 726.411 62C792.129 16 862.362 0 987.276 0Z",
    fill: "#1C0C5B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerTeam);
export default __webpack_public_path__ + "static/media/divider_team.b46f246995581f9908d3c19244c41f26.svg";
export { ForwardRef as ReactComponent };